import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの免許証情報を更新する
 *
 * @param {Number} uid ユーザID
 * @param {Object} license 免許証情報
 * @returns {Response} レスポンスデータ
 */
export function putUserLicense (uid, license) {
  return request.put(`/users/${uid}/license`, license, {
    validateStatus: (status) => [
      http.OK,
      http.BadRequest
    ].includes(status)
  })
}
